import React from 'react'
import { Icon, Typography } from 'antd'
import styles from './index.module.less'

interface InternetLostProps {
	visible: boolean
}

const Authenticating = ({ visible }: InternetLostProps) => {
	return (
		<div hidden={!visible} className={styles.wrapper}>
			<div>
				<Icon className={styles.icon} type='loading' spin />
				<Typography.Title level={3}>Authenticating user.</Typography.Title>
				<Typography.Title type='secondary' level={4}>
					Getting user and making sure you are authenticated.
				</Typography.Title>
			</div>
		</div>
	)
}

export default Authenticating
